export const groupLogo = 'https://performly-dev-assets.s3.eu-west-1.amazonaws.com/winner%20thumbnail%202x_1746692386072.png';


export const emojiAttributes: any = {
    'all': 'All',
    '1f44d': 'Like',
    '2764-fe0f': 'Heart',
    '1f389': 'Celebration',
    '1f31f': 'Excellent',
    '1f973': 'Cheer',
}